module.exports = __webpack_public_path__ + "img/colorBox2.1c98a2da.jpg";